import React from 'react';
import {PostshopLocation} from "../../../models/PostshopLocation";
import {ConnectedReduxProps} from "../../../redux/ConnectedReduxProps";
import PostshopCard from "./PostshopCard/PostshopCard";
import "./ResultsList.scss"
import {CircularProgress} from "@material-ui/core";
import {List, ListItem} from "@material-ui/core";
import NotFoundCard from "../../lib/NotFoundCard/NotFoundCard";
import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";

interface PropsFromState {
  results: PostshopLocation[];
  loadingResults: boolean;
  resultsNotFound: boolean;
  messageTitle: string;
  messageText: string;
  selectedFilter: string;
}

type ResultsProps = PropsFromState & ConnectedReduxProps;

const ResultsList = (props: any) => {
  const {
    results,
    loadingResults,
    resultsNotFound,
    messageTitle,
    messageText,
    selectedFilter
  }: ResultsProps = props;


  const showLoading = loadingResults && !resultsNotFound;

  if (messageTitle || messageText) {
    return <NotFoundCard
      title={messageTitle}
      children={messageText}
    />
  }
  //Filter if selectedFilter is not empty;
  let filteredResults = isEmpty(selectedFilter) ? results : filter(results, (location) => {
    return includes(location.services, selectedFilter);
  });

  const maxAmountResults = filteredResults.length > 50 ? 50 : filteredResults.length;

  filteredResults = filteredResults.slice(0, maxAmountResults);

  if (results.length < 1 && filteredResults.length < 1) {
    //initial state, when user hasnt searched yet
    return null;
  } else if (results.length > 0 && filteredResults.length < 1) {
    return <NotFoundCard
      title={"We can't find a match for your search."}
      children={"Please check the address you’ve entered and try again - avoiding characters such as !#$%^@."}
    />
  }

  return <div id="results-list-container" className="results-list-container">
    {showLoading
      ? <CircularProgress size={35}/>
      : <List className="result-list-items">
        {filteredResults.map((postshop, i) =>
          <ListItem key={`postshop-${postshop.id}`} className="result-list-item">
            <PostshopCard postshop={postshop} key={`postshop-${postshop.id}`} expanded={i === 0}/>
          </ListItem>
        )}
      </List>}
  </div>;
};

export default ResultsList;


// WEBPACK FOOTER //
// ./src/components/PostshopLocator/ResultsList/ResultsList.tsx